import React from 'react'
import { connect } from 'react-redux'
import '../api/components-examples/Admin/admin.css'
import TopLayer from '../api/components-examples/Admin/topLayerComponent'
import MainErrorBoundaryMainContent from '../api/components-examples/utils/ErrorBoundary/MainErrorBoundaryMainContent'
import NewVerticalNavigation from '../VerticalNavigation'
import './index.css'
import WaitingLoader from '../UI-components/Templates/WaitingLoader'

const MainDashboardWrapper = ({
  items,
  activeItem,
  myProfile,
  location,
  changeCurrentTab,
  myTemplates,
  myApps,
  dispatch,
  checkUberDeployment,
  myReccTemplates,
  api,
  children,
  history,
  dataset,
  myUserAccountInfo,
  persisted,
  error,
  theme,
  buildInfo,
  userProjectPermissions,
  planType,
  project_access_removed
}) => {
  const [themes, setThme] = React.useState(theme !== undefined && theme.action === null ? 'light' : theme.action.theme)
  React.useEffect(() => {
    if (theme.action !== null) {
      setThme(theme.action.theme)
    }
  })

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  React.useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const userName =
    persisted.userInformation !== null && persisted.userInformation.name !== undefined
      ? persisted.userInformation.name
      : ''

  const noOrgs =
    project_access_removed ||
      (myUserAccountInfo &&
        (!myUserAccountInfo.rolesUser ||
          !myUserAccountInfo.rolesUser.organizations ||
          myUserAccountInfo.rolesUser.organizations.length === 0))
      ? true
      : false

  return (
    <>
      <TopLayer themes={themes} planType={planType} noOrgs={noOrgs} />
      <MainErrorBoundaryMainContent history={history} error={error}>
        {persisted.userId ? (
          <div className="body-content">
            {!noOrgs && myUserAccountInfo &&
              myUserAccountInfo.current_logged_user &&
              <div className={`left-portion ${windowWidth <= 700 ? 'em-mobile' : ''}`}>
                <NewVerticalNavigation
                  items={items}
                  history={history}
                  dataset={dataset}
                  myUserAccountInfo={myUserAccountInfo}
                  activeItem={activeItem}
                  myProfile={myProfile}
                  currentPath={location.pathname}
                  changeCurrentTab={changeCurrentTab}
                  myApps={myApps}
                  myTemplates={myTemplates}
                  checkUberDeployment={checkUberDeployment}
                  myReccTemplates={myReccTemplates}
                  dispatch={dispatch}
                  api={api}
                  theme={themes}
                  buildInfo={buildInfo}
                  userProjectPermissions={userProjectPermissions}
                  noOrgs={noOrgs}
                />
              </div>
            }
            {api === null ? null : (
              <div className={'right-portion'}>{children}</div>
            )}
          </div>
        ) : (
          <div className="centreLoadingSpinner" style={{ height: 'calc( 100vh - 50px )' }}>
            <WaitingLoader message={`Hey ${userName} We're setting up your workspace. This shouldn't take long 😉`} />
          </div>
        )}
      </MainErrorBoundaryMainContent>
    </>
  )
}

const mapStateToProps = state => ({
  api: state.api,
  apiError: state.apiError,
  myProfile: state.myProfile,
  myHelpLinks: state.myHelpLinks,
  datoinServices: state.datoinServices,
  bgStatus: state.bgStatus,
  myApps: state.myApps,
  myTemplates: state.myTemplates,
  myReccTemplates: state.myReccTemplates,
  checkUberDeployment: state.checkUberDeployment,
  theme: state.theme,
  currentContext: state.currentContext,
  myUserAccountInfo: state.myUserAccountInfo,
  dataset: state.emlycreateFetchMyNewDatasetsRSAAReducer.dataset,
  persisted: state.userProfilePersisted,
  buildInfo: state.buildInfo,
  userProjectPermissions: state.userProjectPermissions
})

export default connect(mapStateToProps)(MainDashboardWrapper)
